export const agentReducer = (
  state = {
    loading: false,
    agents: null,
    agentView: null,
    interviews: null,
    updatingDocuments: false,
    updatingAccount: false,
    updatingCategory: false,
    notificationStatus: null,
    timeslots: null,
    timeslotCount: null,
    wholeDayLoading: false,
    timeslotLoading: false,
    updatingFeatured: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    // ——— AGENT LIST ———
    case "GET_AGENT_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "GET_AGENT_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        agents: action.payload,
        error: null,
      };

    case "GET_AGENT_LIST_FAILED":
      return {
        ...state,
        loading: false,
        agents: null,
        error: action.payload,
      };

    // ——— AGENT VIEW ———
    case "GET_AGENT_LIST_VIEW_REQUEST":
      return {
        ...state,
        loading: true,
        agentView: null,
        error: null,
      };

    case "GET_AGENT_LIST_VIEW_SUCCESS":
      return {
        ...state,
        loading: false,
        agentView: action.payload,
        error: null,
      };

    case "GET_AGENT_LIST_VIEW_FAILED":
      return {
        ...state,
        loading: false,
        agentView: null,
        error: action.payload,
      };

    // ——— UPDATE STAFF DOCUMENTS ———
    case "UPDATE_STAFF_DOCUMENTS_REQUEST":
      return {
        ...state,
        updatingDocuments: true,
        error: null,
      };

    case "UPDATE_STAFF_DOCUMENTS_SUCCESS":
      return {
        ...state,
        updatingDocuments: false,
        agentView: action.payload.data || action.payload,
        error: null,
      };

    case "UPDATE_STAFF_DOCUMENTS_FAILED":
      return {
        ...state,
        updatingDocuments: false,
        error: action.payload,
      };

    case "UPDATE_PROFILE_STATUS_REQUEST":
      return {
        ...state,
        updatingAccount: true,
        error: null,
      };

    case "UPDATE_PROFILE_STATUS_SUCCESS":
      return {
        ...state,
        updatingAccount: false,
        agentView: action.payload.data || action.payload,
        error: null,
      };

    case "UPDATE_PROFILE_STATUS_FAILED":
      return {
        ...state,
        updatingAccount: false,
        error: action.payload,
      };

    // ——— UPDATE AGENT CATEGORY ———
    case "UPDATE_AGENT_CATEGORY_REQUEST":
      return {
        ...state,
        updatingCategory: true,
        error: null,
      };

    case "UPDATE_AGENT_CATEGORY_SUCCESS":
      return {
        ...state,
        updatingCategory: false,
        agentView: action.payload.data || action.payload,
        error: null,
      };

    case "UPDATE_AGENT_CATEGORY_FAILED":
      return {
        ...state,
        updatingCategory: false,
        error: action.payload,
      };

    // ——— INTERVIEW LIST ———
    case "GET_INTERVIEW_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "GET_INTERVIEW_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        interviews: action.payload,
        error: null,
      };

    case "GET_INTERVIEW_LIST_FAILED":
      return {
        ...state,
        loading: false,
        interviews: null,
        error: action.payload,
      };

    // ——— UPDATE INTERVIEW ———
    case "UPDATE_INTERVIEW_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "UPDATE_INTERVIEW_SUCCESS":
      return {
        ...state,
        loading: false,
        interviews: action.payload.data || state.interviews,
        error: null,
      };

    case "UPDATE_INTERVIEW_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ——— NOTIFICATION ———
    case "SEND_AGENT_NOTIFICATION_REQUEST":
      return {
        ...state,
        loading: true,
        notificationStatus: null,
        error: null,
      };

    case "SEND_AGENT_NOTIFICATION_SUCCESS":
      return {
        ...state,
        loading: false,
        notificationStatus: action.payload,
        error: null,
      };

    case "SEND_AGENT_NOTIFICATION_FAILED":
      return {
        ...state,
        loading: false,
        notificationStatus: null,
        error: action.payload,
      };

    // ——— TIMESLOT LIST (new) ———
    case "GET_TIMESLOT_LIST_REQUEST":
      return {
        ...state,
        timeslotLoading: true,
        error: null,
      };

    case "GET_TIMESLOT_LIST_SUCCESS":
      return {
        ...state,
        timeslotLoading: false,
        timeslots: action.payload.data,
        timeslotCount: action.payload.count,
        error: null,
      };

    case "GET_TIMESLOT_LIST_FAILED":
      return {
        ...state,
        timeslotLoading: false,
        timeslots: null,
        timeslotCount: null,
        error: action.payload,
      };

    // ——— DISABLE WHOLE DAY ———
    case "DISABLE_WHOLE_DAY_REQUEST":
      return {
        ...state,
        timeslotLoading: true,
        error: null,
      };

    case "DISABLE_WHOLE_DAY_SUCCESS":
      return {
        ...state,
        timeslotLoading: false,
        error: null,
      };

    case "DISABLE_WHOLE_DAY_FAILED":
      return {
        ...state,
        timeslotLoading: false,
        error: action.payload,
      };

    // ——— ENABLE WHOLE DAY ———
    case "ENABLE_WHOLE_DAY_REQUEST":
      return {
        ...state,
        timeslotLoading: true,
        error: null,
      };

    case "ENABLE_WHOLE_DAY_SUCCESS":
      return {
        ...state,
        timeslotLoading: false,
        error: null,
      };

    case "ENABLE_WHOLE_DAY_FAILED":
      return {
        ...state,
        timeslotLoading: false,
        error: action.payload,
      };

    case "APPROVE_REJECT_STAFF_UPDATE_REQUEST_REQUEST":
      return { ...state, loading: true };
    case "APPROVE_REJECT_STAFF_UPDATE_REQUEST_SUCCESS":
      return { ...state, loading: false };
    case "APPROVE_REJECT_STAFF_UPDATE_REQUEST_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "AGENT_ROLE_UPDATE_REQUEST":
      return { ...state, loading: true };
    case "AGENT_ROLE_UPDATE_SUCCESS":
      return { ...state, loading: false };
    case "AGENT_ROLE_UPDATE_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "ASSIGN_FRANCHISE_MANAGER_REQUEST":
      return {
        ...state,
        assigningFranchise: true,
        error: null,
      };

    case "ASSIGN_FRANCHISE_MANAGER_SUCCESS":
      return {
        ...state,
        assigningFranchise: false,
        agentView: action.payload.data || action.payload,
        error: null,
      };

    case "ASSIGN_FRANCHISE_MANAGER_FAILED":
      return {
        ...state,
        assigningFranchise: false,
        error: action.payload,
      };

    case "LIST_STAFF_UPDATE_REQUEST_REQUEST":
      return { ...state, loading: true, staffUpdateRequests: null };
    case "LIST_STAFF_UPDATE_REQUEST_SUCCESS":
      return { ...state, loading: false, staffUpdateRequests: action.payload };
    case "LIST_STAFF_UPDATE_REQUEST_FAILED":
      return { ...state, loading: false, staffUpdateRequests: null, error: action.payload };

    // ——— UPDATE AGENT FEATURED ———
    case "UPDATE_AGENT_FEATURED_REQUEST":
      return {
        ...state,
        updatingFeatured: true,
        error: null,
      };

    case "UPDATE_AGENT_FEATURED_SUCCESS":
      return {
        ...state,
        updatingFeatured: false,
        agentView: action.payload.data || action.payload,
        error: null,
      };

    case "UPDATE_AGENT_FEATURED_FAILED":
      return {
        ...state,
        updatingFeatured: false,
        error: action.payload,
      };

    // STOP_LOADING: keep this generic or inside each case; your current thunk uses "STOP_LOADING"
    case "STOP_LOADING":
      return {
        ...state,
        loading: false,
        timeslotLoading: false,
      };

    default:
      return state;
  }
};
